import {
  GET_VM_DETAILS,
  SET_VM_DETAILS,
  SET_VPP_TEMPLATES,
  GET_COURSE_DATA_BY_ID_SUCCESS,
  GET_COURSE_DATA_BY_ID_FAILURE,
  GET_OS_LIST,
  SET_OS_LIST,
  SET_OS_VERSIONS,
  SET_NIC_NETWORK,
  SET_NIC_NETWORK_ADAPTER_TYPES,
  SET_NIC_IP_MODES,
  SET_ALL_VAPP_TEMPLATES_AND_VMS,
  GET_ALL_VAPP_TEMPLATES_AND_VMS,
  SAVE_UPDATE_COURSE_DEFINITION,
  SAVE_UPDATE_COURSE_DEF_ERROR,
  SAVE_UPDATE_COURSE_DEF_SUCCESS,
  PUBLISH_COURSE_DEFINITION,
  RESET_COURSE_CREATION_STATE,
  VM_POWER_OFF_PROGRESS,
  VM_POWER_ON_PROGRESS,
  RESET_VM_POWER_OPERATION,
  RESET_COURSE_DEF_DATA,
  TOKEN_GETTING_REFRESHED,
  SET_MOUNT_ISO_ACADEMY,
  SET_UN_MOUNT_ISO_ACADEMY,
  MOUNTING_IN_PROGRESS,
  UN_MOUNTING_IN_PROGRESS,
  RESET_MEDIA_OPERATION,
  RESET_MOUNT_STATUS,
  RESET_UN_MOUNT_STATUS,
} from "../utils/constants";
import {
  INetworkList,
  INetworkAdapter,
  INicIPModes,
  IVAppTemplate,
  IOSTypes,
  IOSVersions,
} from "../model/index";

const initialState = {
  vmDetails: {
    tableData: [] as any[],
    isTableLoading: false,
  },
  vAppTemplatesList: {
    tableData: { vAppTemplates: [] as IVAppTemplate[] },
    isTableLoading: false,
  },
  courseDefinitionData: {
    loading: false,
    courseDefData: [],
    error: null,
  },
  courseCreation: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  vmPowerOffInProgress: false,
  vmPowerOnInProgress: false,
  mountingInprogress: false,
  unMountingInprogress: false,
  tokenStatus: false,
  isoMountStatus: null,
  isoMountMessage: null,
  isoUnmountStatus: null,
  isoUnmountMessage: null,
  vAppTemplates: [] as IVAppTemplate[],
  osList: [] as IOSTypes[],
  osVersions: [] as IOSVersions[],
  networkList: [] as INetworkList[],
  nicNetworkAdapterTypes: [] as INetworkAdapter[],
  nicIpModes: [] as INicIPModes[],
};
export const createCourseReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_VPP_TEMPLATES: {
      return {
        ...state,
        vAppTemplates: action.response,
      };
    }
    case GET_VM_DETAILS: {
      return {
        ...state,
        vmDetails: {
          tableData: [],
          isTableLoading: true,
        },
      };
    }
    case SET_VM_DETAILS: {
      return {
        ...state,
        vmDetails: {
          tableData: action.response,
          isTableLoading: false,
        },
      };
    }
    case GET_ALL_VAPP_TEMPLATES_AND_VMS: {
      if (action.pageNo === 1) {
        return {
          ...state,
          vAppTemplatesList: {
            tableData: { vAppTemplates: [] as IVAppTemplate[] },
            isTableLoading: true,
          },
        };
      }
      return {
        ...state,
        vAppTemplatesList: {
          ...state.vAppTemplatesList,
          isTableLoading: true,
        },
      };
    }
    case SET_ALL_VAPP_TEMPLATES_AND_VMS: {
      return {
        ...state,
        vAppTemplatesList: {
          tableData: {
            ...action.response,
            vAppTemplates: [
              ...(state.vAppTemplatesList.tableData?.vAppTemplates || []),
              ...(action.response.vAppTemplates || []),
            ],
          },
          isTableLoading: false,
        },
      };
    }
    case GET_COURSE_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        courseDefinitionData: {
          loading: false,
          courseDefData: action.response,
          error: null,
        },
      };
    case GET_COURSE_DATA_BY_ID_FAILURE:
      return {
        ...state,
        courseDefinitionData: {
          loading: false,
          courseDefData: [],
          error: action.response,
        },
      };
    case RESET_COURSE_DEF_DATA:
      return {
        ...state,
        courseDefinitionData: {
          loading: false,
          courseDefData: [],
          error: null,
        },
      };
    case GET_OS_LIST:
      return {
        ...state,
        osVersions: [],
      };
    case SET_OS_LIST:
      return {
        ...state,
        osList: action.response,
      };
    case SET_OS_VERSIONS:
      return {
        ...state,
        osVersions: action.response,
      };
    case SET_NIC_NETWORK:
      return {
        ...state,
        networkList: action.response,
      };
    case SET_NIC_NETWORK_ADAPTER_TYPES:
      return {
        ...state,
        nicNetworkAdapterTypes: action.response,
      };
    case SET_NIC_IP_MODES:
      return {
        ...state,
        nicIpModes: action.response,
      };
    case SAVE_UPDATE_COURSE_DEFINITION:
      return {
        ...state,
        courseCreation: {
          isLoading: true,
          isSuccess: false,
          isError: false,
          error: null,
        },
      };
    case SAVE_UPDATE_COURSE_DEF_ERROR:
      return {
        ...state,
        courseCreation: {
          isLoading: false,
          isSuccess: false,
          isError: true,
          error: action.response,
        },
      };
    case SAVE_UPDATE_COURSE_DEF_SUCCESS:
      return {
        ...state,
        courseCreation: {
          isLoading: false,
          isSuccess: true,
          isError: false,
          error: action.response,
        },
      };
    case PUBLISH_COURSE_DEFINITION:
      return {
        ...state,
        courseCreation: {
          isLoading: true,
          isSuccess: false,
          isError: false,
          error: null,
        },
      };
    case RESET_COURSE_CREATION_STATE:
      return {
        ...state,
        courseCreation: {
          isLoading: false,
          isSuccess: false,
          isError: false,
          error: null,
        },
      };
    case VM_POWER_OFF_PROGRESS:
      return {
        ...state,
        vmPowerOffInProgress: action.response,
      };
    case VM_POWER_ON_PROGRESS:
      return {
        ...state,
        vmPowerOnInProgress: action.response,
      };
    case RESET_VM_POWER_OPERATION:
      return {
        ...state,
        vmPowerOnInProgress: false,
        vmPowerOffInProgress: false,
      };
    case MOUNTING_IN_PROGRESS:
      return {
        ...state,
        mountingInprogress: true,
      };
    case UN_MOUNTING_IN_PROGRESS:
      return {
        ...state,
        unMountingInprogress: true,
      };
    case RESET_MEDIA_OPERATION:
      return {
        ...state,
        mountingInprogress: false,
        unMountingInprogress: false,
      };

    case TOKEN_GETTING_REFRESHED:
      return {
        ...state,
        tokenStatus: action.response,
      };
    case SET_MOUNT_ISO_ACADEMY:
      return {
        ...state,
        isoMountStatus: action.response?.status,
        isoMountMessage:
          action.response?.status === 200
            ? action.response?.data
            : action.response?.response?.data,
      };
    case SET_UN_MOUNT_ISO_ACADEMY:
      return {
        ...state,
        isoUnmountStatus: action.response?.status,
        isoUnmountMessage:
          action.response?.status === 200
            ? action.response?.data
            : action.response?.response?.data,
      };
    case RESET_MOUNT_STATUS:
      return {
        ...state,
        isoMountStatus: null,
        isoMountMessage: null,
      };
    case RESET_UN_MOUNT_STATUS:
      return {
        ...state,
        isoUnmountStatus: null,
        isoUnmountMessage: null,
      };

    default:
      return state;
  }
};
